/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CallDealerModal_item$ref = any;
export type CallDealerModal_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly " $refType": CallDealerModal_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CallDealerModal_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '8a0622c8f30902723b719505e0e1dab5';
export default node;
